import { useState } from 'react';

import { InputGroup, InputGroupText, Select } from 'twyne-new.ui';

import { useCraftProp } from '@/components/builder/utils';

import ToggleGroup from './ToggleGroup';

export default function OverscrollProperty() {
  const { value: all, setValue: setAll } = useCraftProp('overscroll.value')
  const { value: x, setValue: setX } = useCraftProp('overscroll.x')
  const { value: y, setValue: setY } = useCraftProp('overscroll.y')
  const [type, setType] = useState('all')

  const toggleOptions = [
    { value: 'all', tooltip: 'All', icon: 'all' },
    { value: 'axis', tooltip: 'Axis', icon: 'axis' },
  ]

  const handlerReset = value => {
    const setters = value === 'all' ? [setX, setY] : [setAll]
    setters.forEach(setter => setter(undefined))
    setType(value)
  }

  return <>
    <div className='flex flex-col gap-1'>
      <div className='flex items-center gap-1'>
        <Select
          options={OPTIONS}
          value={type === 'all' && all}
          onChange={item => setAll(item?.value)}
          variant='accent'
          disabled={type !== 'all'}
          clearable
        />
        <ToggleGroup
          name='overflow.type'
          options={toggleOptions}
          type='single'
          value={type}
          onChange={handlerReset}
        />
      </div>

      {type === 'axis' && <>
        <div className='flex gap-1 w-full'>
          <InputGroup variant='accent' className='w-full'>
            <InputGroupText addonType='prepend'>
              X
            </InputGroupText>
            <Select
              options={OPTIONS}
              value={x}
              onChange={item => setX(item?.value)}
              variant='accent'
              clearable
            />
          </InputGroup>
          <InputGroup variant='accent' className='w-full'>
            <InputGroupText addonType='prepend'>
              Y
            </InputGroupText>
            <Select
              options={OPTIONS}
              value={y}
              onChange={item => setY(item?.value)}
              variant='accent'
              clearable
            />
          </InputGroup>
        </div>
      </>}
    </div>
  </>
}

const OPTIONS = [
  { label: 'Auto', value: 'auto' },
  { label: 'Contain', value: 'contain' },
  { label: 'None', value: 'none' },
]

